module.exports = "\r\n<div id=\"{{'htmlEditor' + txtId}}\" [innerHTML]=\"txtContent | safeHtml\" >  \r\n    \r\n</div>\r\n\r\n<div *ngIf=\"maxlength > 0\" class=\"row\" style=\"text-align:right\">\r\n    <span>Remaining character:&nbsp; <b> {{ txtMaxlengthIndicator }} </b> out of&nbsp;<b> {{ maxlength }} </b></span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/igtexteditor.control.html
// module id = ../../../../../client/app/shared/controls/igtexteditor.control.html
// module chunks = main